import { useContext } from 'react';

import { ChainsPrivateStatsContext } from '../const';

export const useChainsPrivateStatsParams = () =>
  useContext(ChainsPrivateStatsContext);
